/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OtpType {
    LOGIN = 'Login',
    CHANGE_PASSWORD = 'ChangePassword',
}
